import axios from 'axios'
import { LISTAR_FILTROS_ITINERARIO } from '../types'
import { URL } from '../../util/ambienteActions';

export default function listarFiltrosItinerario (idEmpresa) {
  const url = `${URL}/itinerario/empresa/${idEmpresa}/filtros`

  return dispatch => axios.get(url).then(
      response => dispatch({
        type: LISTAR_FILTROS_ITINERARIO,
        payload: response

      })
  );
}
